import NewsDetails from 'views/news/NewsDetails';

export default {
	'components.NewsDetails': {
		factory: NewsDetails,
		deps: [{ $ref: 'components.base.NewsDetails' }, { $ref: 'components.Image' }],
	},
};
